module.exports = __webpack_public_path__ + "img/178.160a248a.png";